import {Component} from '@angular/core';

@Component({
    selector: 'scitis-required-field-indicator',
    templateUrl: './required-field-indicator.component.html',
    styleUrls: ['./required-field-indicator.component.scss'],
    standalone: false
})
export class RequiredFieldIndicatorComponent {
}
